import http from "@/shared/api/http";

export async function createCart(name) {
  const res = await http.post("cart", { name });
  const data = res.data;

  return data?.value ?? data ?? null;
}

export async function getMyCarts() {
  const res = await http.get("cart/my");

  const data = res.data;

  return data?.value ?? data ?? [];
}

export async function getCartById(id) {
  const res = await http.get(`cart/byId/${id}`);
  const data = res.data;

  return data?.value ?? data ?? null;
}

export async function updateCart(payload) {
  return (await http.put("cart", payload)).data;
}

export async function deleteCart(cartId) {
  return (await http.delete(`cart/${cartId}`)).data;
}
